module.exports = __webpack_public_path__ + "media/promo/courses/images/desk-3293e8d5299479f11d8cf1c15ed9cd9d.png";